module.exports = __webpack_public_path__ + "static/media/right.4746f05b.png";